import { type ComponentType, type FC } from "react";

import { type IconProps } from "@snapchat/snap-design-system-icons";

import { tableTextStyle } from "../../layout/components";
import { Flexbox } from "../../shared/components";

import { VisibilityContent, VisibilityText, icon } from "./VisibilityLensRow.styles";

interface VisibilityLensRowProps {
    Icon: ComponentType<IconProps>;
    label: string;
    className?: string;
    dataTestId?: string;
}

export const VisibilityLensRow: FC<VisibilityLensRowProps> = ({ Icon, label, className, dataTestId }) => {
    return (
        <Flexbox className={className} justifyContent="flex-start" alignItems="center" data-testid={dataTestId}>
            <Icon className={icon} />
            <VisibilityContent>
                <VisibilityText className={tableTextStyle}>{label}</VisibilityText>
            </VisibilityContent>
        </Flexbox>
    );
};
